/**
 * Textos da página do resultado auditado (E153.F3, GUS-176, ADR-0104 §2.6): o que o sistema
 * preparou do caso para compor o laudo e as demais saídas — a conferência, a identidade do
 * resultado, o que cada saída pode consumir, a matriz pública de cada requisito com o estado interno
 * por expansão, os achados com destino, os artefatos registrados e o contrato por expansão. É
 * material da equipe; nada aqui afirma validade, nulidade ou efeito do contrato.
 */
export const ptBRResultado = {
  titulo: 'Resultado auditado',
  subtitulo:
    'O que o sistema preparou do caso para compor o laudo e as demais saídas: a conferência, a evidência, a matriz pública de cada requisito, os achados e os artefatos registrados. A página mostra; não decide nem registra.',
  voltar: 'Voltar ao caso',
  verResultado: 'Ver resultado estruturado',
  carregando: 'Carregando o resultado auditado…',
  erro: 'Não foi possível carregar o resultado auditado. Tente novamente.',
  tentarDeNovo: 'Tentar de novo',
  limite:
    'Nenhum campo do resultado afirma validade civil, nulidade, fraude ou efeito do contrato; o estado interno de cada requisito é conservado e a interpretação pública é a da versão indicada.',
  recusa: {
    sem_permissao: 'O resultado auditado é da equipe que atende o caso.',
    nao_encontrado: 'Caso não encontrado.',
    fora_da_raia: 'O resultado auditado existe só para o exame de assinatura eletrônica.',
    indisponivel: 'Não foi possível carregar o resultado auditado. Tente novamente.',
  },
  situacao: {
    aguardando_processamento: 'Aguardando processamento',
    pendencia_tecnica: 'Pendência técnica',
    em_conferencia: 'Em conferência',
    preparado: 'Preparado',
  },
  situacaoTexto: {
    aguardando_processamento:
      'Ainda não há avaliação da formalização gravada para este caso; nada é consumível.',
    pendencia_tecnica:
      'A etapa "Resultado auditado" não liberou; nenhuma saída consome o resultado até a pendência sair.',
    em_conferencia:
      'A etapa liberou com o juízo do perito pendente: a minuta composta continua proposta até a revisão na mesa.',
    preparado: 'A etapa liberou com a conclusão definida: o resultado está pronto para compor.',
  },
  resumo: {
    titulo: 'Resumo da conferência',
    etapa: 'Etapa "Resultado auditado"',
    aguardando: 'Aguardando',
    consumivel: 'Consumível pelas saídas',
    naoConsumivel: 'Não consumível',
    caso: 'Caso {codigo}',
    rodada: 'Rodada {rodada}',
    registradaEm: 'Registrada em {data}',
    modo: 'Modo do exame',
    pecas: '{n} peça(s) viva(s)',
    codigo: 'Código do resultado',
    entrada: 'Entrada',
    fluxo: 'Fluxo',
    semFluxo: 'sem impressão do fluxo (versão anterior)',
    qaTitulo: 'Conferência de veracidade',
    qaVersao: 'versão {versao}',
    bloqueante: 'bloqueante',
  },
  qa: {
    aprovado: 'Aprovada',
    corrigir: 'A corrigir',
    bloqueado: 'Bloqueada',
  },
  // E170.F2.C03 (reteste de 25/10, GUS-229 bloco 1): o contrato é a exigência de assinatura e os
  // dados para compor a prévia — nada aqui diz que houve assinatura ou entrega ao cliente.
  compositores: {
    titulo: 'Informações aos compositores',
    subtitulo:
      'Os dados que cada saída tem para compor a prévia, se pode ir aos autos ou é de uso interno e se exige assinatura; a decisão e as versões que o resultado carrega. Não indica assinatura feita nem entrega ao cliente: esses estados ficam no pacote e na entrega.',
    colunas: {
      saida: 'Saída',
      regime: 'Destino',
      assinatura: 'Exige assinatura',
      disponivel: 'Dados para compor a prévia',
    },
    sim: 'Sim',
    nao: 'Não',
    disponivel: 'Disponíveis',
    indisponivel: 'Indisponíveis',
    decisao: 'Decisão',
    conclusao: 'Conclusão',
    proposta: 'Proposta ao perito',
    semProposta: 'sem proposta',
    juizoPendente: 'Exame sem conclusão: falta material decisivo (veja o que falta abaixo).',
    juizoDefinido: 'Conclusão definida pelo perito.',
    juizoDoSistema: 'Conclusão apurada pelo sistema · prévia',
    leituraEscolhida: 'Leitura que sustenta',
    semLeitura: 'Nenhuma leitura sustenta ainda.',
    razao: 'Razão da escolha',
    versoes: 'Versões',
    catalogo: 'Catálogo',
    criterioDoGrau: 'Critério do grau',
    veracidade: 'Conferência de veracidade',
    interpretacao: 'Interpretação pública',
    reguaDasEtapas: 'Régua das etapas',
    evidencia: 'Evidência',
    fontes: '{n} fonte(s)',
    fatos: '{n} fato(s)',
    naoExtraidos: '{n} não extraído(s)',
    inferencias: '{n} afirmação(ões) derivada(s)',
    imagens: '{n} imagem(ns)',
  },
  kind: {
    laudo: 'Laudo',
    resumo: 'Resumo executivo',
    evidencias: 'Evidências',
    riscos: 'Orientações para o jurídico',
  },
  // E170.F2.C03: o destino da saída, não um estado da entrega ("Liberado" lia como entregue).
  regime: {
    liberado: 'Juntável aos autos',
    reservado: 'Uso interno, não juntar aos autos',
  },
  motivoDoConsumo: {
    aguardando_processamento: 'Aguardando processamento',
    pendencia_tecnica: 'Pendência técnica na etapa',
    em_conferencia: 'Em conferência',
    preparado: 'Preparado',
    reservado_fora_do_modo_parte: 'Reservado: só no modo PARTE',
    fora_da_raia: 'Fora do exame de assinatura eletrônica',
  },
  prontidao: {
    titulo: 'Próximo passo',
    indisponivel: 'Não foi possível ler o estado do caso agora. Tente novamente.',
    pendencias: 'O que falta, na ordem ({n})',
    peca: 'Peça {peca}',
    etapa: 'Etapa: {etapa}',
    // E184.F4 (GUS-145 item 7, GT-2026-0247): o juízo pendente diz o que falta, não só o motivo.
    faltam: 'Falta para a conclusão: {faltam}',
    faltamArquivos: 'O caso aguarda arquivos: {faltam}',
    // E209.F2.T09 (GUS-296 item 8): a saída que falhou; o "Resolver" leva ao "Retomar" do pacote.
    saidaQueFalhou: 'A prévia não foi refeita. {motivo} Retome a preparação na aba Exame.',
    // E162.F2.T01: a tela onde o passo se faz; nela mesma, a faixa diz que é aqui.
    nestaTela: 'É nesta tela.',
    // E201.F1 (GUS-47): a pré-análise e a mesa são a mesa única; o passo leva à área dele.
    abrir: {
      pre_analise: 'Ir aos documentos',
      mesa: 'Ir à conclusão',
      saidas: 'Abrir a conferência do laudo',
      certificacao: 'Conferir e assinar',
      banco: 'Ir ao campo do banco',
      // E203.F5.T08: o bloco da mesa que resolve o passo.
      protocolo: 'Abrir protocolo e documentos',
      leitura: 'Ir à leitura dos documentos',
      envio: 'Adicionar documentos',
    },
  },
  proximoPasso: {
    receber: 'Receber a CCB do caso',
    verificar: 'Verificar as peças',
    concluir_ccb: 'Registrar a conclusão da CCB (facultativo)',
    conferir_leitura: 'Conferir a leitura do caso',
    corrigir_etapa: 'Corrigir a etapa que não liberou',
    revisar_proposta: 'Ver o que falta para concluir o exame',
    homologar: 'Homologar o caso',
    conferir_saida: 'Conferir a saída',
    revisar_saidas: 'Revisar as saídas desta versão',
    assinar: 'Assinar o laudo',
    liberar: 'Laudo assinado: liberar ao cliente',
    informar_banco: 'Informar o banco do caso',
    enviar_arquivos: 'Enviar os arquivos que faltam',
    // E205.F3 (ADR-0147 §5): as pendências que não seguram saída nenhuma.
    confirmar_leitura: 'Confirmar a leitura do documento',
    conferir_apoio: 'Conferir a leitura do documento de apoio',
  },
  motivoDaProntidao: {
    sem_ccb: 'O caso não tem CCB recebida',
    exame_pendente: 'Peça ainda não verificada',
    verificacao_desalinhada: 'Peça verificada com outro protocolo ou outra régua',
    regua_anterior: 'Peça verificada com a régua anterior',
    conclusao_pendente: 'Conclusão da CCB não registrada',
    leitura_em_conferencia: 'Leitura do caso em conferência',
    etapa_em_conferencia: 'A conferência da etapa não liberou',
    avaliacao_pendente: 'Avaliação não gerada sobre as entradas de hoje',
    juizo_pendente: 'Falta material decisivo para a conclusão (diligências na mesa)',
    revisao_pendente: 'Homologação exigida e não registrada',
    saida_nao_conferida: 'Saída ainda não conferida',
    saida_reprovada: 'Saída conferida e reprovada',
    saidas_nao_revisadas: 'Exame sem a marca de revisão do perito',
    assinatura_pendente: 'Laudo conferido; falta assinar',
    banco_pendente: 'Banco do caso não informado: a prévia sai, a emissão final espera',
    aguardando_arquivos: 'O caso aguarda arquivos e não é analisado até chegar o que falta',
    leitura_proposta:
      'Leitura proposta sem conferência: os dados entram no exame com o arquivo e a página',
    apoio_a_conferir: 'Documento de apoio sem leitura confirmada: o exame não lê a proposta',
    ponto_do_perito: 'Ponto da conferência da leitura para o perito ver',
  },
  matriz: {
    titulo: 'Matriz pública',
    subtitulo:
      'Cada requisito da leitura com a interpretação pública e, por expansão, o estado interno conservado: situação, suporte, rota, elementos e o que falta.',
    escolhida: 'Leitura que sustenta',
    subsidiaria: 'Subsidiária',
    prioridade: 'Prioridade {n}',
    semLeituras: 'Nenhuma leitura admissível nesta rodada.',
    codigo: 'Código',
    consideracoes: 'Considerações',
    interno: 'Estado interno',
    situacaoInterna: 'Situação',
    suporte: 'Suporte',
    semSuporte: 'sem rota',
    rota: 'Rota',
    elementos: 'Elementos',
    semElementos: 'nenhum',
    faltam: 'Faltam: {itens}',
    convergencia: 'Convergência pessoa + ato',
    motivo: 'Motivo',
  },
  situacaoDaLeitura: {
    sustenta: 'Sustenta',
    sustenta_sob_revisao: 'Sustenta sob revisão',
    nao_sustenta: 'Não sustenta',
    irregular: 'Irregular',
    pendente_normativa: 'Pendência normativa',
    inadmissivel: 'Inadmissível',
  },
  estadoDaAnalise: {
    concluida: 'Concluída',
    nao_executada: 'Não executada',
  },
  publico: {
    atendido: 'ATENDIDO',
    nao_violada: 'NÃO VIOLADA',
    parcial: 'PARCIAL',
    pendente: 'PENDENTE',
    nao_demonstrado: 'NÃO DEMONSTRADO',
    nao_se_aplica: 'NÃO SE APLICA',
    irregular: 'IRREGULAR',
  },
  reasonCode: {
    REGULAR_ROUTE: 'Rota regular completa',
    REQ_SUPPLIED: 'Requisito suprido',
    NOT_VIOLATED: 'Exigência não violada',
    IRREGULAR_REQ: 'Requisito contrariado',
    REQ_NOT_REQUIRED: 'Requisito não exigido',
    PENDING: 'Pendente de revisão ou diligência',
    NATURE_UNMAPPED: 'Natureza não mapeada',
    NOT_DEMONSTRATED: 'Não demonstrado',
  },
  suporte: {
    primario: 'Primário (rota SUF)',
    suplementar: 'Suplementar (SUP-F-3)',
  },
  classe: {
    declarado: 'Declarado',
    verificado: 'Verificado pelo sistema',
    consulta_externa: 'Consulta externa',
  },
  achados: {
    titulo: 'Achados com destino',
    subtitulo:
      'O que a análise de riscos encontrou, com o destino de cada achado (laudo essencial ou reservado) e a situação da busca.',
    busca: 'Situação da busca',
    estado: 'Análise',
    cobertura: 'Cobertura',
    criterio: 'Critério',
    laudoEssencial: 'No laudo essencial: {n}',
    riscosReservados: 'No reservado: {n}',
    reservadoAgora: 'O reservado é composto nesta rodada.',
    reservadoNao: 'O reservado não é composto nesta rodada.',
    semAchados: 'Nenhum achado listado.',
  },
  situacaoDaBusca: {
    nao_executada: 'Não executada',
    nao_conferida: 'Executada sem conferência aprovada — a lista não se lê como vazia',
    com_achados: 'Com achados',
    sem_achados_no_alcance: 'Sem achados no alcance',
  },
  artefatos: {
    titulo: 'Artefatos registrados',
    subtitulo:
      'O que cada compositor registrou deste caso, com a situação contra a última avaliação. A avaliação nova não apaga: o artefato dela sai desatualizado. Na mesma versão, só o mais novo de cada tipo é o vigente; os anteriores saem substituídos.',
    vazio: 'Nenhum artefato registrado ainda.',
    colunas: {
      saida: 'Saída',
      versao: 'Versão',
      etapa: 'Etapa',
      aprovacao: 'Aprovação',
      situacao: 'Situação',
      registrado: 'Registrado em',
    },
    sobre: 'sobre a rodada {rodada}',
    layout: 'layout {layout}',
    comEmissao: 'com emissão registrada',
  },
  etapaDoArtefato: {
    rascunho: 'Rascunho',
    final: 'Final',
  },
  aprovacao: {
    minuta: 'Minuta',
    conclusao_definida: 'Conclusão definida',
  },
  situacaoDoArtefato: {
    vigente: 'Vigente',
    substituido: 'Substituído',
    desatualizado: 'Desatualizado',
  },
  contrato: {
    titulo: 'Contrato completo',
    texto: 'O que a rota devolve, como os compositores leem.',
    esquema: 'Esquema {schema}',
  },
};
